import { Button } from 'antd';
import { useNavigate, Link } from 'react-router-dom';
import styles from './index.module.css';

const Submitted = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.submittedPage}>
      <div className={styles.background} />
      <div className={styles.content}>
        <div className={styles.title}>
          <div className={styles.cheersIcon}></div>
          <div>You&apos;re all set.</div>
        </div>
        <div className={styles.description}>
          Your shoppers will start
          seeing Estimated Delivery Date on your site starting Tue, Jan 25.
        </div>
        <Link to="/">
          <Button className={styles.backButton}>Back to Home</Button>
        </Link>
      </div>
      <div className={styles.banner}>
        <div className={styles.bannerText}>
          Upgrade to GUARANTEED
          Delivery Date and turn late deliveries into repeat customers.
        </div>
        <Button className={styles.bannerButton} onClick={() => navigate('/application/gdd')}>Free upgrade now →</Button>
      </div>
    </div>
  );
};

export { Submitted };
